// extracted by mini-css-extract-plugin
module.exports = {"list":"Account_list_2qx5R","cardwrap":"Account_cardwrap_3brep","card":"Account_card_1MLfy","icon":"Account_icon_12tTr"};